/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Notification} from '../bioplanModels';
// @ts-ignore
import type {UpdateReadNotification} from '../bioplanModels';
// @ts-ignore
import type {WriteNotification} from '../bioplanModels';
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Batch delete notification
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsDelete: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('notificationsDelete', 'planId', planId);
      const localVarPath = `/notifications/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all notifications for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('notificationsGet', 'planId', planId);
      const localVarPath = `/notifications/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete notifications
     * @param {string} notificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsNotificationIdDelete: async (
      notificationId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'notificationId' is not null or undefined
      assertParamExists('notificationsNotificationIdDelete', 'notificationId', notificationId);
      const localVarPath = `/notifications/{notificationId}`.replace(
        `{${'notificationId'}}`,
        encodeURIComponent(String(notificationId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get notification
     * @param {string} notificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsNotificationIdGet: async (
      notificationId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'notificationId' is not null or undefined
      assertParamExists('notificationsNotificationIdGet', 'notificationId', notificationId);
      const localVarPath = `/notifications/{notificationId}`.replace(
        `{${'notificationId'}}`,
        encodeURIComponent(String(notificationId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update notification
     * @param {string} notificationId
     * @param {UpdateReadNotification} updateReadNotification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsNotificationIdPatch: async (
      notificationId: string,
      updateReadNotification: UpdateReadNotification,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'notificationId' is not null or undefined
      assertParamExists('notificationsNotificationIdPatch', 'notificationId', notificationId);
      // verify required parameter 'updateReadNotification' is not null or undefined
      assertParamExists('notificationsNotificationIdPatch', 'updateReadNotification', updateReadNotification);
      const localVarPath = `/notifications/{notificationId}`.replace(
        `{${'notificationId'}}`,
        encodeURIComponent(String(notificationId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateReadNotification,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Batch update notifications
     * @param {Array<WriteNotification>} writeNotification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsPatch: async (
      writeNotification: Array<WriteNotification>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'writeNotification' is not null or undefined
      assertParamExists('notificationsPatch', 'writeNotification', writeNotification);
      const localVarPath = `/notifications/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(writeNotification, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Batch delete notification
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notificationsDelete(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsDelete(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NotificationsApi.notificationsDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all notifications for a plan
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notificationsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NotificationsApi.notificationsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete notifications
     * @param {string} notificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notificationsNotificationIdDelete(
      notificationId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsNotificationIdDelete(
        notificationId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NotificationsApi.notificationsNotificationIdDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get notification
     * @param {string} notificationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notificationsNotificationIdGet(
      notificationId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsNotificationIdGet(notificationId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NotificationsApi.notificationsNotificationIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update notification
     * @param {string} notificationId
     * @param {UpdateReadNotification} updateReadNotification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notificationsNotificationIdPatch(
      notificationId: string,
      updateReadNotification: UpdateReadNotification,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsNotificationIdPatch(
        notificationId,
        updateReadNotification,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NotificationsApi.notificationsNotificationIdPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Batch update notifications
     * @param {Array<WriteNotification>} writeNotification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async notificationsPatch(
      writeNotification: Array<WriteNotification>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsPatch(writeNotification, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['NotificationsApi.notificationsPatch']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = NotificationsApiFp(configuration);
  return {
    /**
     *
     * @summary Batch delete notification
     * @param {NotificationsApiNotificationsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsDelete(
      requestParameters: NotificationsApiNotificationsDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .notificationsDelete(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all notifications for a plan
     * @param {NotificationsApiNotificationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsGet(
      requestParameters: NotificationsApiNotificationsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Notification>> {
      return localVarFp.notificationsGet(requestParameters.planId, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete notifications
     * @param {NotificationsApiNotificationsNotificationIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsNotificationIdDelete(
      requestParameters: NotificationsApiNotificationsNotificationIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .notificationsNotificationIdDelete(requestParameters.notificationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get notification
     * @param {NotificationsApiNotificationsNotificationIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsNotificationIdGet(
      requestParameters: NotificationsApiNotificationsNotificationIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Notification> {
      return localVarFp
        .notificationsNotificationIdGet(requestParameters.notificationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update notification
     * @param {NotificationsApiNotificationsNotificationIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsNotificationIdPatch(
      requestParameters: NotificationsApiNotificationsNotificationIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Notification> {
      return localVarFp
        .notificationsNotificationIdPatch(
          requestParameters.notificationId,
          requestParameters.updateReadNotification,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Batch update notifications
     * @param {NotificationsApiNotificationsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    notificationsPatch(
      requestParameters: NotificationsApiNotificationsPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Notification>> {
      return localVarFp
        .notificationsPatch(requestParameters.writeNotification, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for notificationsDelete operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationsDeleteRequest
 */
export interface NotificationsApiNotificationsDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof NotificationsApiNotificationsDelete
   */
  readonly planId: string;
}

/**
 * Request parameters for notificationsGet operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationsGetRequest
 */
export interface NotificationsApiNotificationsGetRequest {
  /**
   *
   * @type {string}
   * @memberof NotificationsApiNotificationsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for notificationsNotificationIdDelete operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationsNotificationIdDeleteRequest
 */
export interface NotificationsApiNotificationsNotificationIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof NotificationsApiNotificationsNotificationIdDelete
   */
  readonly notificationId: string;
}

/**
 * Request parameters for notificationsNotificationIdGet operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationsNotificationIdGetRequest
 */
export interface NotificationsApiNotificationsNotificationIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof NotificationsApiNotificationsNotificationIdGet
   */
  readonly notificationId: string;
}

/**
 * Request parameters for notificationsNotificationIdPatch operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationsNotificationIdPatchRequest
 */
export interface NotificationsApiNotificationsNotificationIdPatchRequest {
  /**
   *
   * @type {string}
   * @memberof NotificationsApiNotificationsNotificationIdPatch
   */
  readonly notificationId: string;

  /**
   *
   * @type {UpdateReadNotification}
   * @memberof NotificationsApiNotificationsNotificationIdPatch
   */
  readonly updateReadNotification: UpdateReadNotification;
}

/**
 * Request parameters for notificationsPatch operation in NotificationsApi.
 * @export
 * @interface NotificationsApiNotificationsPatchRequest
 */
export interface NotificationsApiNotificationsPatchRequest {
  /**
   *
   * @type {Array<WriteNotification>}
   * @memberof NotificationsApiNotificationsPatch
   */
  readonly writeNotification: Array<WriteNotification>;
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
  /**
   *
   * @summary Batch delete notification
   * @param {NotificationsApiNotificationsDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  public notificationsDelete(
    requestParameters: NotificationsApiNotificationsDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NotificationsApiFp(this.configuration)
      .notificationsDelete(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all notifications for a plan
   * @param {NotificationsApiNotificationsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  public notificationsGet(requestParameters: NotificationsApiNotificationsGetRequest, options?: RawAxiosRequestConfig) {
    return NotificationsApiFp(this.configuration)
      .notificationsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete notifications
   * @param {NotificationsApiNotificationsNotificationIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  public notificationsNotificationIdDelete(
    requestParameters: NotificationsApiNotificationsNotificationIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NotificationsApiFp(this.configuration)
      .notificationsNotificationIdDelete(requestParameters.notificationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get notification
   * @param {NotificationsApiNotificationsNotificationIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  public notificationsNotificationIdGet(
    requestParameters: NotificationsApiNotificationsNotificationIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NotificationsApiFp(this.configuration)
      .notificationsNotificationIdGet(requestParameters.notificationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update notification
   * @param {NotificationsApiNotificationsNotificationIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  public notificationsNotificationIdPatch(
    requestParameters: NotificationsApiNotificationsNotificationIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NotificationsApiFp(this.configuration)
      .notificationsNotificationIdPatch(
        requestParameters.notificationId,
        requestParameters.updateReadNotification,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Batch update notifications
   * @param {NotificationsApiNotificationsPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationsApi
   */
  public notificationsPatch(
    requestParameters: NotificationsApiNotificationsPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NotificationsApiFp(this.configuration)
      .notificationsPatch(requestParameters.writeNotification, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
